import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	row2: {
		display: "grid",
		gridGap: theme.spacing(3),
		gridTemplateColumns: "1fr",
		gridTemplateRows: "auto auto",
		[theme.breakpoints.up("md")]: {
			alignItems: "center",
			gridTemplateColumns: "150px auto",
			gridTemplateRows: "auto",
			"& .mco-footer__metamenu": {
				marginLeft: "auto"
			}
		}
	}
}));

export default styles;
